import React, { useState } from 'react';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { List, MagnifyingGlass, Moon, Sun } from '@phosphor-icons/react';
import NotificationBell from '@/components/layout/NotificationBell';
import HelpMenu from '@/components/HelpMenu';
import HelpBot from '@/components/HelpBot';

export default function TopBar({
  setSidebarOpen,
  darkMode,
  setDarkMode,
  notificationsUnread,
  badgeCounts,
  notificationItems,
  navigate,
  initials,
  refreshNotifications,
  onReplayTour,
}) {
  const [helpOpen, setHelpOpen] = useState(false);

  return (
    <>
      <style>{`@keyframes helpBotFloat { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-3px); } }`}</style>
      <header className="h-14 flex items-center justify-between px-4 border-b border-border bg-card">
        <div className="flex items-center gap-3">
          <button onClick={() => setSidebarOpen(true)} className="p-2 -ml-2 rounded-md hover:bg-muted md:hidden" data-testid="mobile-menu-btn">
            <List size={24} />
          </button>
          <div className="hidden sm:flex items-center">
            <button
              onClick={() => {
                const event = new KeyboardEvent('keydown', { key: 'k', metaKey: true, ctrlKey: true });
                document.dispatchEvent(event);
              }}
              className="relative flex items-center w-64 h-9 bg-muted/50 rounded-md px-3 text-sm text-muted-foreground hover:bg-muted transition-colors"
              data-testid="global-search-trigger"
            >
              <MagnifyingGlass size={16} className="mr-2" />
              <span>Search contacts, messages...</span>
              <kbd className="absolute right-2 hidden lg:inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground">⌘K</kbd>
            </button>
          </div>
        </div>
        <div className="flex items-center gap-1 sm:gap-2">
          <button
            onClick={() => setHelpOpen(!helpOpen)}
            className="relative flex items-center justify-center hover:scale-110 active:scale-95 transition-transform bg-transparent border-none"
            title="LotMate Help"
            data-testid="helpbot-trigger"
            style={{ animation: helpOpen ? 'none' : 'helpBotFloat 3s ease-in-out infinite', filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.35))' }}
          >
            <img src="/logo.svg" alt="Help" className="w-8 h-8 sm:w-11 sm:h-11 object-contain" style={{ marginTop: '-4px', marginBottom: '-4px' }} />
          </button>
          {/* HelpMenu hidden on small phones — accessible via sidebar on mobile */}
          <span className="hidden sm:inline-flex">
            <HelpMenu onReplayTour={onReplayTour} />
          </span>
          <button onClick={() => setDarkMode(!darkMode)} className="p-1.5 sm:p-2 rounded-md hover:bg-muted transition-colors" data-testid="dark-mode-toggle">
            {darkMode ? <Sun size={18} /> : <Moon size={18} />}
          </button>
          <NotificationBell
            notificationsUnread={notificationsUnread}
            badgeCounts={badgeCounts}
            notificationItems={notificationItems}
            navigate={navigate}
            refreshNotifications={refreshNotifications}
          />
          <div className="md:hidden">
            <Avatar className="w-7 h-7 sm:w-8 sm:h-8">
              <AvatarFallback className="bg-primary text-primary-foreground text-[10px] sm:text-xs font-medium">
                {initials}
              </AvatarFallback>
            </Avatar>
          </div>
        </div>
      </header>
      <HelpBot open={helpOpen} setOpen={setHelpOpen} />
    </>
  );
}
